import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { numberFormatter, hasLocationData } from "../../helper/helpers";
import PhoneInput from "react-phone-input-2";
import { useMutation } from "@tanstack/react-query";
import { basketCheckoutApi } from "../../services/products";
import { getLoggedinUser } from "../../lib/axios-client";
import { toast } from "sonner";
import {
  useGetLocations,
  useGetStoresLocations,
} from "../../hooks/useProducts";
import { AlertComponent } from "./AlertComponent";
// import { setGeolocation } from "../features/system/systemSlice";
import GeolocationMap from "./GeolocationMap";
import DeliveryOption from "./DeliveryOption";

const Checkout = () => {
  let formEl = React.useRef();
  const navigate = useNavigate();

  let { user = {} } = getLoggedinUser();

  let { addresses = [] } = user;

  const [errorArray, setErrorArray] = useState([]);
  // const [useDifferentBilling, setUseDifferentBilling] = useState(false);
  const [shippingMethod, setShippingMethod] = useState("1");
  const [isMapShown, setIsMapShown] = useState(false);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [isLoadingConfirmation, setIsLoadingnConfirmation] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState("1");
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  // const {
  //   geolocation: { latitude, longitude },
  // } = useSelector((state) => state.system);
  const [locationMode, setLocationMode] = useState("");
  const [geolocation, setLocation] = useState({
    latitude: null,
    longitude: null,
  });

  const { cart } = useSelector((state) => state.itemCart);

  const locationParams = React.useMemo(() => {
    if (!geolocation?.latitude || !geolocation?.longitude) return {};

    return {
      latitude: geolocation.latitude,
      longitude: geolocation.longitude,
    };
  }, [geolocation.latitude, geolocation.longitude]);

  const {
    data: locationData = {},
    // isPending: isLoadingLocation,
    isError: locationIsError,
    error: locationError,
  } = useGetLocations(locationParams);

  const {
    data = {},
    isError: storeIsError,
    error: storeError,
  } = useGetStoresLocations({
    userLat: null,
    userLng: null,
  });

  let { stores = [] } = data;

  let subTotal = cart.reduce(
    (acc, curr) => acc + curr.unitPrice * curr.quantity,
    0,
  );

  let total = subTotal;

  const [formData, setFormData] = useState({
    shippingAddress: {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      emailAddress: user?.email ?? "",
      addressLine: "",
      county: "",
      city: "",
      postalCode: "",
      landmark: "",
      country: "",
    },
    // billingAddress: { ...emptyAddress },
    payment: {
      method: "1",
      phoneNumber: "",
      transactionReference: null,
      cardName: null,
      cardNumberMasked: null,
    },
    StoreId: "",
    notes: "",
    billingAddress: null,
  });

  // const paymentEnumMap = {
  //   payment1: 1, // Mpesa
  //   payment2: 2, // Card
  //   payment3: 3, // Paybill
  //   payment4: 4, // CashOnDelivery
  // };

  const handlePaymentChange = (event) => {
    setSelectedPayment(event.target.id);

    setFormData({
      ...formData,
      payment: {
        ...formData.payment,
        // method: paymentEnumMap[event.target.id],
        method: event.target.id,
      },
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      shippingAddress: {
        ...prev.shippingAddress,
        [name]: value,
      },
    }));
    // Clear error dynamically
    setValidationErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleAddressChange = (event) => {
    const { value } = event.target;
    setSelectedAddress(value);
    if (!value) return;
    let data = JSON.parse(value);
    setFormData((prev) => ({
      ...prev,
      shippingAddress: {
        ...prev.shippingAddress,
        addressLine: data?.addressLine1 ?? "",
        county: data?.county ?? "",
        city: data?.city ?? "",
        postalCode: data?.country ?? "",
        landmark: data?.landmark ?? "",
        country: data?.country ?? "",
      },
    }));
  };

  const handlePaymentPhone = (value, country, e, formattedValue) => {
    setFormData({
      ...formData,
      payment: {
        ...formData.payment,
        phoneNumber: value,
      },
    });
  };

  const handleAddressPhone = (value, country, e, formattedValue) => {
    setFormData({
      ...formData,
      shippingAddress: {
        ...formData.shippingAddress,
        phoneNumber: value,
      },
      payment: {
        ...formData.payment,
        phoneNumber: value,
      },
    });
  };

  const onOpenMapChange = () => {
    setIsMapShown(!isMapShown);
  };

  const handleModeChange = (mode) => {
    // dispatch(setLocationMode(mode));
    setLocationMode(mode);
    setSelectedAddress(null);
    if (mode === "auto") {
      setFormData((prev) => ({
        ...prev,
        shippingAddress: {
          ...prev.shippingAddress,
          addressLine: "",
          county: "",
          city: "",
          country: "",
        },
      }));
      getCurrentLocation(); // trigger browser prompt
      return;
    }
    // DO NOT clear location immediately for manual
    // let user pick first
    if (mode === "manual") {
      onOpenMapChange();
    }
  };

  const handleLocationChange = (coords) => {
    setLocation({
      latitude: coords?.latitude,
      longitude: coords?.longitude,
    });
  };

  const getCurrentLocation = () => {
    if (!("geolocation" in navigator)) {
      alert("Geolocation is not supported by your browser");
      return;
    }
    setIsLoadingLocation(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
        // dispatch(
        //   setGeolocation({
        //     latitude: position.coords.latitude,
        //     longitude: position.coords.longitude,
        //     source: "auto",
        //   }),
        // );

        setIsLoadingLocation(false);
      },
      (error) => {
        switch (error.code) {
          case 1:
            // Permission denied
            alert(
              "Location access is blocked. Please enable it in your browser settings.",
            );
            break;

          case 2:
            alert(
              "Unable to detect your location. Try again or select manually.",
            );
            break;

          case 3:
            alert("Location request timed out. Please try again.");
            break;

          default:
            alert("An unknown error occurred while fetching location.");
        }
        setIsLoadingLocation(false);
        // toast.error("Please enable location access in your browser settings");
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
      },
    );
  };

  const { mutate: CheckoutBasket, isPending } = useMutation({
    mutationFn: basketCheckoutApi,
    onSuccess: (data) => {
      toast.success("Your order has been processed successfully.");
      setIsLoadingnConfirmation(true);
      setTimeout(() => {
        navigate("/checkout/payment", {
          state: { ...data, paymentMethod: formData["payment"].method },
        });
        // dispatch(clearLocalCart());
      }, 12000);
    },
    onError: (err) => {
      let error = [];
      error.push(err);
      setIsLoadingnConfirmation(false);
      setErrorArray(error);
      console.log(err);
      toast.error(error || "Unable to process your order.");
    },
  });

  const validateForm = () => {
    const errors = {};

    const {
      firstName,
      lastName,
      phoneNumber,
      emailAddress,
      addressLine,
      // county,
      // city,
      // postalCode,
      country,
    } = formData.shippingAddress;

    if (shippingMethod === "1" && !firstName.trim()) {
      errors.firstName = "First name is required";
    }

    if (shippingMethod === "1" && !lastName.trim()) {
      errors.lastName = "Last name is required";
    }

    if (shippingMethod === "1" && !phoneNumber.trim()) {
      errors.phoneNumber = "Phone number is required";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (shippingMethod === "1" && !emailAddress.trim()) {
      errors.emailAddress = "Email is required";
    } else if (!emailRegex.test(emailAddress)) {
      errors.emailAddress = "Invalid email address";
    }

    if (shippingMethod === "1" && !addressLine.trim()) {
      errors.addressLine = "Address is required";
    }

    // if (!county.trim()) {
    //   errors.county = "County is required";
    // }

    // if (!city.trim()) {
    //   errors.city = "City is required";
    // }

    // if (!postalCode.trim()) {
    //   errors.postalCode = "Postal code is required";
    // }

    if (selectedPayment === "1" && !country.trim()) {
      errors.country = "Country is required";
    }

    // Pickup validation
    if (shippingMethod === "2" && !formData.StoreId) {
      errors.StoreId = "Please select a pickup station";
    }

    // Payment validation
    if (selectedPayment === "1" && !formData.payment.phoneNumber) {
      errors.paymentPhone = "Payment phone number is required";
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();

    const isValid = validateForm();

    if (!isValid) {
      toast.error("Please fill all required fields");
      return;
    }

    const payload = {
      basketCheckout: {
        userName: user?.userName,
        customerId: user?.id,
        items: cart.map((product) => {
          return {
            productId: product.productId,
            quantity: product.quantity,
          };
        }),
        // shippingAddress: {
        //   ...formData.shippingAddress,
        //   location: { ...locationData, label: locationData.formattedAddress },
        // },
        shippingAddress:
          shippingMethod === "1"
            ? {
                ...formData.shippingAddress,
                location: {
                  ...locationData,
                  label: locationData.formattedAddress,
                },
              }
            : null,
        billingAddress:
          shippingMethod === "2"
            ? {
                ...formData.shippingAddress,
                location: {
                  ...locationData,
                  label: locationData.formattedAddress,
                },
              }
            : null,
        // billingAddress: useDifferentBilling
        //   ? formData.billingAddress
        //   : formData.shippingAddress,
        CollectionType: Number(shippingMethod),
        // billingAddress: formData.billingAddress,
        StoreId: !formData.StoreId ? null : formData.StoreId,
        payment: {
          ...formData.payment,
          method: Number(formData.payment.method),
        },
        // notes: formData.notes,
        useShippingAsBilling: shippingMethod === "1",
      },
    };
    CheckoutBasket(payload);
  };

  React.useEffect(() => {
    if (!hasLocationData(locationData)) return;

    setFormData((prev) => {
      // don't override if user already typed
      // if (prev.shippingAddress.addressLine) return prev;
      // ONLY block if user is in manual mode AND has typed
      // if (locationMode === "manual" && prev.shippingAddress.addressLine) {
      //   return prev;
      // }

      return {
        ...prev,
        shippingAddress: {
          ...prev.shippingAddress,
          addressLine: locationData.formattedAddress || "",
          county: locationData.county || "",
          city: locationData.city || "",
          country: locationData.country || "",
        },
      };
    });
  }, [locationData, locationMode]);

  React.useEffect(() => {
    const errs = [];

    if (locationIsError) errs.push(`location: ${locationError}`);
    if (storeIsError) errs.push(`Stores: ${storeError}`);

    setErrorArray(errs);
  }, [locationIsError, locationError, storeIsError, storeError]);

  if (cart?.length === 0) {
    return <Navigate to={"/"} replace state={null} />;
  }

  return (
    <section className="checkout py-30 bg-grey-50">
      <div className="container container-lg">
        {Boolean(errorArray.length) && (
          <AlertComponent errorArray={errorArray} />
        )}

        <div className="row">
          {isLoadingLocation && (
            <span className="d-flex justify-content-center py-20">
              <div
                className="spinner-border spinner-border-sm me-5 align-self-center"
                role="status"
              ></div>
              <h6 className="m-0">Getting location ...</h6>
            </span>
          )}

          <div className="col-xl-7 col-lg-7">
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <div className="bg-color-three rounded-8 p-10 text-center mb-24">
                  <span className="text-gray-900 text-xl fw-semibold">
                    Billing Address
                  </span>
                </div>
                {/* Shipping Form */}
                <form
                  ref={formEl}
                  autoComplete="off"
                  onSubmit={handlePlaceOrder}
                >
                  <div className="border border-gray-100 rounded-8 px-30 py-20 mb-40">
                    <div className="row">
                      <div className="col-12 col-sm-6 d-flex justify-content-between">
                        <div className="form-check form-check-inline align-content-center">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="locationMode"
                            id="manual"
                            value={"manual"}
                            onChange={(e) => handleModeChange(e.target.value)}
                            disabled={isLoadingLocation}
                            checked={locationMode === "manual"}
                          />
                          <label
                            className="form-check-label fw-bold"
                            htmlFor="Receipts"
                          >
                            Change Location
                          </label>
                        </div>
                        <div className="form-check form-check-inline align-content-center">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="locationMode"
                            id="auto"
                            value={"auto"}
                            onChange={(e) => handleModeChange(e.target.value)}
                            disabled={isLoadingLocation}
                            checked={locationMode === "auto"}
                          />
                          <label
                            className="form-check-label fw-bold"
                            htmlFor="Payments"
                          >
                            Use Current Location
                          </label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-floating">
                          <select
                            className="form-select form-select-sm"
                            id="addressSelect"
                            aria-label="Floating label select example"
                            onChange={(e) => {
                              handleAddressChange(e);
                              handleModeChange("");
                            }}
                            value={selectedAddress}
                            disabled={isLoadingLocation}
                          >
                            <option value={""}>Open this select menu</option>
                            {addresses?.map((item, index) => (
                              <option value={JSON.stringify(item)} key={index}>
                                {`${index + 1}:- ${item.addressLine1}, ${item.city}, ${item.county}, ${item.country}`}
                              </option>
                            ))}
                          </select>
                          <label htmlFor="addressSelect">Saved Address</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {shippingMethod === "1" && (
                    <div className="row gy-3">
                      <div className="col-12 col-sm-6">
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            className={`form-control ${
                              validationErrors.firstName ? "is-invalid" : ""
                            }`}
                            value={formData.shippingAddress.firstName}
                            id="firtName"
                            name="firstName"
                            onChange={handleInputChange}
                            required
                          />
                          <label htmlFor="firtName">FirstName</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            className={`form-control ${
                              validationErrors.lastName ? "is-invalid" : ""
                            }`}
                            id="lastName"
                            name="lastName"
                            value={formData.shippingAddress.lastName}
                            onChange={handleInputChange}
                            required
                          />
                          <label htmlFor="lastName">LastName</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <PhoneInput
                          country={"ke"}
                          value={formData.shippingAddress.phoneNumber}
                          inputProps={{
                            id: "phonenumber",
                            name: "phonenumber",
                          }}
                          inputStyle={{
                            width: "100%",
                            fontSize: "12px",
                            lineHeight: "1.5",
                            height: "calc(3.5rem + calc(1px * 2))",
                            // height: " calc(1.5em + 0.5rem + 2px)",
                          }}
                          id="phonenumber"
                          name="phonenumber"
                          masks={{ ke: "... ... ..." }}
                          onChange={handleAddressPhone}
                          required
                        />
                        {validationErrors.phoneNumber && (
                          <div className="text-danger small mt-1">
                            {validationErrors.phoneNumber}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-floating mb-3">
                          <input
                            type="email"
                            className={`form-control ${
                              validationErrors.emailAddress ? "is-invalid" : ""
                            }`}
                            id="emailAddress"
                            name="emailAddress"
                            value={formData.shippingAddress.emailAddress}
                            onChange={handleInputChange}
                            required
                          />
                          <label htmlFor="emailAddress">Email</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-floating mb-3">
                          <textarea
                            type="text"
                            className={`form-control ${
                              validationErrors.addressLine ? "is-invalid" : ""
                            }`}
                            id="addressLine"
                            name="addressLine"
                            value={formData.shippingAddress.addressLine}
                            onChange={handleInputChange}
                            required
                          ></textarea>
                          <label htmlFor="addressLine">Address</label>
                        </div>
                      </div>
                      {/* <div className="col-12 col-sm-6">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className={`form-control ${
                            validationErrors.county ? "is-invalid" : ""
                          }`}
                          id="county"
                          name="county"
                          value={formData.shippingAddress.county}
                          onChange={handleInputChange}
                          required
                        />
                        <label htmlFor="county">County</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className={`form-control ${
                            validationErrors.city ? "is-invalid" : ""
                          }`}
                          id="city"
                          name="city"
                          value={formData.shippingAddress.city}
                          onChange={handleInputChange}
                          required
                        />
                        <label htmlFor="city">City</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className={`form-control `}
                          id="postalCode"
                          name="postalCode"
                          value={formData.shippingAddress.postalCode}
                          onChange={handleInputChange}
                          required
                        />
                        <label htmlFor="postalCode">postalCode</label>
                      </div>
                    </div> */}
                      <div className="col-12 col-sm-6">
                        <div className="form-floating mb-3">
                          <textarea
                            type="text"
                            className={`form-control`}
                            id="landmark"
                            name="landmark"
                            value={formData.shippingAddress.landmark}
                            onChange={handleInputChange}
                            required
                          ></textarea>
                          {validationErrors.landmark && (
                            <div className="text-danger small mt-1">
                              {validationErrors.landmark}
                            </div>
                          )}
                          <label htmlFor="landmark">Landmark</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            className={`form-control ${
                              validationErrors.country ? "is-invalid" : ""
                            }`}
                            id="country"
                            name="country"
                            value={formData.shippingAddress.country}
                            onChange={handleInputChange}
                            required
                          />
                          <label htmlFor="country">Country</label>
                        </div>
                      </div>
                      {/* Map through shipping fields */}
                    </div>
                  )}
                  {/* Billing Address Checkbox */}
                  <span className="text-gray-900 text-xl fw-semibold p-10">
                    Shipping Mehtod
                  </span>

                  <div className="d-flex justify-content-between gap-16">
                    <DeliveryOption
                      value="1"
                      selected={shippingMethod}
                      onChange={setShippingMethod}
                      title="Home Delivery"
                      subtitle="Standard delivery rates"
                      icon="🚚"
                    />

                    <DeliveryOption
                      value="2"
                      selected={shippingMethod}
                      onChange={setShippingMethod}
                      title="Station Pickup"
                      subtitle="Free of charge"
                      icon="📦"
                    />
                  </div>

                  {shippingMethod === "2" && (
                    <>
                      <div className="form-floating mt-10">
                        <select
                          className="form-select"
                          id="addressSelect"
                          aria-label="Floating label select example"
                          value={selectedAddress}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              StoreId: e.target.value,
                            })
                          }
                        >
                          <option value={""}>Select a station</option>
                          {stores?.map((store, index) => (
                            <option value={store.id} key={index}>
                              {store.name}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="addressSelect">Store Locations</label>
                      </div>
                      <div
                        className="alert alert-primary mt-10 py-1"
                        role="alert"
                      >
                        <p className="m-0 text-xs p-0 fw-semibold ">
                          <i className="ph ph-warning-circle me-5"></i>
                          PICK UP YOUR ORDER FREE OF CHARGE FROM YOUR SELECTED
                          STATION. YOU WILL RECEIVE NOTIFICATION WHEN ITS READY
                        </p>
                      </div>
                    </>
                  )}
                </form>

                {/* {hasLocationData(locationData) && (
                  <div className="mt-10">
                    <div className="border border-gray-100 rounded-8 px-30 py-20 mb-40">
                      {Object.entries(locationData).map((item, index) => (
                        <p
                          className="m-0 d-flex justify-content-between"
                          key={index}
                        >
                          <span>{item[0]}: </span>
                          <span>{item[1]}</span>
                        </p>
                      ))}
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>

          {/* Sidebar / Order Summary & Payment */}
          <div className="col-xl-5 col-lg-5">
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <div className="checkout-sidebar">
                  <div className="bg-color-three rounded-8 p-10 text-center">
                    <span className="text-gray-900 text-xl fw-semibold">
                      Order Summary
                    </span>
                  </div>
                  <div className="border border-gray-100 rounded-8 px-24 py-10 mt-24">
                    <div className="mb-16 pb-10 border-bottom border-gray-100 flex-between gap-8">
                      <span className="text-gray-900 fw-medium text-xl font-heading-two">
                        Product
                      </span>
                      <span className="text-gray-900 fw-medium text-xl font-heading-two">
                        Subtotal
                      </span>
                    </div>
                    {cart?.map((product) => (
                      <div
                        className="flex-between gap-24 mb-16 flex-wrap"
                        key={product.id}
                      >
                        <div className="flex-align gap-12">
                          <span className="text-gray-900 fw-normal text-md font-heading-two">
                            * {product.productName}
                          </span>
                          <span className="text-gray-900 fw-normal text-md font-heading-two">
                            <i className="ph-bold ph-x" />
                          </span>
                          <span className="text-gray-900 fw-semibold text-md font-heading-two">
                            {product.quantity}
                          </span>
                        </div>
                        <span className="text-gray-900 fw-bold text-md font-heading-two">
                          {numberFormatter.format(
                            Number(product.unitPrice * product.quantity),
                          )}
                        </span>
                      </div>
                    ))}
                    <div className="border-top border-gray-100 pt-30 mt-15">
                      <div className="mb-32 flex-between gap-8">
                        <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                          Subtotal
                        </span>
                        <span className="text-gray-900 font-heading-two text-md fw-bold">
                          {numberFormatter.format(Number(subTotal))}
                        </span>
                      </div>
                      <div className="mb-32 flex-between gap-8">
                        <span className="text-success-900 font-heading-two text-sm">
                          <i className="ph ph-percent me-5"></i> Promotional
                          Discount
                        </span>
                        <span className="text-gray-900 font-heading-two text-md fw-bold">
                          {numberFormatter.format(0)}
                        </span>
                      </div>
                      {/* <div className="mb-32 flex-between gap-8">
                    <span className="text-gray-900 font-heading-two text-sm">
                      <i className="ph ph-truck me-5"></i> Delivery Fee
                    </span>
                    <span className="text-gray-900 font-heading-two text-md fw-bold">
                      {numberFormatter.format(0)}
                    </span>
                  </div> */}
                      <div className="bg-color-three mb-0 flex-between gap-8 p-10">
                        <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                          Total
                        </span>
                        <span className="text-gray-900 font-heading-two text-md fw-bold">
                          {numberFormatter.format(Number(total))}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Payment Methods */}
                  <div className="mt-32">
                    <h6 className="fw-semibold mb-24">Payment Method</h6>
                    {["1"].map((method) => (
                      <div className="payment-item" key={method}>
                        <div className="form-check common-check common-radio py-16 mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="payment"
                            id={method}
                            checked={selectedPayment === method}
                            onChange={handlePaymentChange}
                          />
                          <label
                            className="form-check-label fw-semibold text-neutral-600"
                            htmlFor={method}
                          >
                            {method === "1"
                              ? "M-PESA"
                              : method === "2"
                                ? "Card Payment"
                                : method === "3"
                                  ? "Paybill"
                                  : "Cash On Delivery"}
                          </label>
                        </div>

                        {/* Payment Content */}
                        {selectedPayment === method && (
                          <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block mt-16">
                            {method === "1" && (
                              <>
                                <label className="mb-8 fw-medium">
                                  Phone Number
                                </label>
                                <PhoneInput
                                  country={"ke"}
                                  value={formData.payment.phoneNumber}
                                  inputClass="form-control"
                                  inputProps={{
                                    id: "phonenumber",
                                    name: "phonenumber",
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    fontSize: "12px",
                                    lineHeight: "1.5",
                                    height: " calc(1.5em + 0.5rem + 2px)",
                                  }}
                                  id="phonenumber"
                                  name="phonenumber"
                                  masks={{ ke: "... ... ..." }}
                                  onChange={handlePaymentPhone}
                                />
                                {/* <input
                                type="text"
                                className="common-input"
                                placeholder="2547XXXXXXXX"
                                value={formData.payment.phoneNumber}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    payment: {
                                      ...formData.payment,
                                      phoneNumber: e.target.value,
                                    },
                                  })
                                }
                              /> */}
                              </>
                            )}
                            {method === "2" && (
                              <>
                                {/* Card Fields */}
                                <div className="mb-16">
                                  <label className="mb-8 fw-medium">
                                    Card Number
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="1234 5678 1234 5678"
                                  />
                                </div>
                              </>
                            )}
                            {method === "3" && (
                              <h6>
                                Use Paybill Number: 123456, Account: Order ID
                              </h6>
                            )}
                            {method === "4" && (
                              <h6>Pay with cash upon delivery.</h6>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  <div className="mt-32 pt-32 border-top border-gray-100">
                    <p className="text-gray-500">
                      Your personal data will be used to process your order,
                      support your experience throughout this website, and for
                      other purposes described in our{" "}
                      <Link
                        to="#"
                        className="text-main-600 text-decoration-underline"
                      >
                        privacy policy
                      </Link>
                      .
                    </p>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-main mt-40 py-18 w-100 rounded-8"
                    disabled={
                      isPending || isLoadingLocation || isLoadingConfirmation
                    }
                    onClick={() =>
                      formEl.current.dispatchEvent(
                        new Event("submit", {
                          cancelable: true,
                          bubbles: true,
                        }),
                      )
                    }
                  >
                    {(isPending ||
                      isLoadingLocation ||
                      isLoadingConfirmation) && (
                      <div
                        className="spinner-border spinner-border-sm me-5"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                    {isLoadingConfirmation
                      ? "Processing order ..."
                      : "Place Order"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GeolocationMap
        isMapShown={isMapShown}
        onOpenMapChange={onOpenMapChange}
        handleLocationChange={handleLocationChange}
        onClose={onOpenMapChange}
      />
    </section>
  );
};

export default Checkout;
